import TemplateView from '../../../TemplateView'
import $ from "jquery"
import ClassicBridge from '../../../next/ClassicBridge'

export default class IframeContent extends TemplateView {

    constructor({
        iframeLoadCallback,
        frameName,
    }) {
        super()

        this.callbacks = {
            iframeLoadCallback,
        }

        this.state = {
            url: '',
            size: {
                width: 0,
                height: 0
            },
        }

        this.params = {
            frameName
        }


        this.onStatePropertyChanged('url', url => {
            if (!url) {
                return
            }

            this.iframe = $('<iframe>', {
                src: url,
                id: this.params.frameName,
                frameborder: 0,
                allowfullscreen: 1,
                width: this.state.size.width,
                height: this.state.size.height,
                name: this.params.frameName,
                // Allow the "unload" event after it is deprecated.
                // The "unload" event is used in ext-base.js which is loaded inside the iframe.
                // See https://jira.actimind.com/browse/AT-11367.
                allow: 'unload',
            })

            this.iframe.appendTo('.iframeContainer')

            this.iframe.load(() => {
                this.find('.iframeContentPlaceholder').hide()
                this.callbacks.iframeLoadCallback(this.params.frameName)
            })
        })

        this.onStatePropertyChanged('size', size => {
            if (this.iframe) {
                this.iframe.width(size.width)
                this.iframe.height(size.height)
            }
        })
    }

    afterRender() {
        ClassicBridge.integrateSpinner(this.find('.iframeContentPlaceholder')[0], {
            spinnerClassName: 'iframeContentSpinner'
        })
    }

    templateHtml() {
        return `<div class="iframeContainer">
                    <div class="iframeContentPlaceholder atNextMount">
                    </div>
                </div>`
    }
}


// WEBPACK FOOTER //
// ./web/js/taskManagement/createLightbox/project/IframeContent.js